const e = {
  escClose: !0,
  closeIcon: "icon-icon-error-4",
  iconSize: 10,
  mask: !0,
  maskClosable: !0,
  childrenMaxHeight: "calc(100vh - 340px)",
  popupType: "article"
};
export {
  e as defaultReoPopupProps
};
//# sourceMappingURL=const.mjs.map
